import React, { useEffect, useState } from 'react';
import Header from "../Component/Header";
import Footer from "../Component/Footer"; 
import { Link } from 'react-router-dom';
import { getTopper } from '../Service/Api';  // Ensure getTopper is correctly imported
import LazyLoad from 'react-lazyload';

const ToppersXII = () => {
  const [data, setData] = useState([]);
  const [filterData, setFilteredData] = useState([]);
  const [selectedYear, setSelectedYear] = useState("");
  const [yearRanges, setYearRanges] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  // Initialize the selected year to the current session year
  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const Year = `${currentYear - 1}-${currentYear}`;
    setSelectedYear(Year);
  }, []);

  // Fetch data and initialize year ranges
  useEffect(() => {
    const fetchData = async () => {
      const galleryData1 = await getTopper();
      const galleryData = galleryData1.filter((item) => item.class === 'XII');
      setData(galleryData);

      // Extract unique session years
      const uniqueYears = Array.from(
        new Set(galleryData.map((item) => item.sessionYear))
      ).sort((a, b) => b.localeCompare(a)); // Sort years in descending order

      setYearRanges(uniqueYears);

      // Check if default year has data; if not, fallback to the last available year
      const currentYear = new Date().getFullYear();
      const defaultYear = `${currentYear - 1}-${currentYear}`;
      const hasDefaultYearData = galleryData.some(
        (item) => item.sessionYear === defaultYear
      );

      if (!hasDefaultYearData && uniqueYears.length > 0) {
        setSelectedYear(uniqueYears[0]); // Set the most recent year as active
      }
    };

    fetchData();
  }, []);

  // Filter data based on the selected year and search query
  useEffect(() => {
    let filteredData = data;

    // Filter by selected year
    if (selectedYear !== "All") {
      filteredData = filteredData.filter((item) => item.sessionYear === selectedYear);
    }

    // Filter by search query
    if (searchQuery) {
      filteredData = filteredData.filter((item) =>
        item.name.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    // Sort data by division in descending order
    filteredData.sort((a, b) => parseFloat(b.division) - parseFloat(a.division));

    setFilteredData(filteredData);
  }, [selectedYear, searchQuery, data]);


  return (
    <>
      <Header/>
      <div className="inner_slider">
        <LazyLoad><img src="https://webapi.entab.info/api/image/SXSBPB/public/Images/inner_slider.jpg" className="img-fluid inner_slider_img" alt="St. Xaviers Bathinda"/> </LazyLoad>
        <div className="row bread_cumb">
          <h2>Toppers XII</h2>
          <div className="theme-heading">
            <span className="colorW marB10"><i className="bi bi-building"></i></span>
          </div>
          <h5><Link to="/">Home <i className="bi bi-arrow-right"></i></Link> <span> Toppers XII</span></h5>
        </div>
      </div>
      <div className="innerpage inner_cont toppers-inner">
        <div className="row tabs-dynamic">
          <div className="col-md-3">
            <div className="month-selection">
                <select
                value={selectedYear}
                onChange={(e) => setSelectedYear(e.target.value)}
                className="yearSelection"
              >
                <option value={"All"}>All</option>
                {yearRanges.map((yr) => (
                  <option key={yr} value={yr}>{yr}</option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-md-3">
            <div className="searchBox">
            <input
            type="text"
            id="myInput"
            name="name"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="Search Here.."
          />
            </div>
          </div>
        </div>
        <div className="row">
        {filterData.length > 0 ? (
          filterData.map((item, index) =>  (
            <div className="col-xl-2 col-lg-4 col-md-4 col-6" key={index}>
              <article> 
                <h5>{item.division}</h5>
                <LazyLoad><img src={item.attachments && item.attachments[0] ? `https://webapi.entab.info/api/image/${item.attachments[0]}` : "/images/trophy.png"} className="img-fluid" alt="St. Xaviers Bathinda" /></LazyLoad>
                <h3>{item.name}</h3>
                <p>{item.stream}</p>
              </article>
            </div>
            ))
            ) : (
            <p>No data found for the selected year.</p>
          )}
        </div>
      </div>
      <Footer/>
    </>
  )
}

export default ToppersXII;
